<template>
  <span>
    <!-- ▼掲載期間見出し -->
    <scout-and-like-period-bar
      :first-date="contract.firstDate"
      :last-date="contract.lastDate"
      :scout-limit="contract.scoutLimit"
      :sent-scout-amount="contract.sentScoutAmount"
      :like-limit="contract.likeLimit"
      :sent-like-amount="contract.sentLikeAmount"
      :reserved-scout-first-send-amount="contract.reservedScoutFirstSendAmount"
    />
    <!-- ▲掲載期間見出し -->
    <div class="boss-contractperiod-wrap">
      <!-- ▼求人掲載リスト -->
      <div class="boss-scoutandlike-container">
        <div class="boss-scoutandlike-wrap">
          <ul class="boss-scoutandlike-list">
            <template v-for="(job, i) in contract.jobs">
              <scout-job-topics
                :key="i"
                :job="job"
                :contract-id="contractId"
                :associated-user-count-with-job="getAssociatedUserCountWithJob(job.id)"
                :is-remaining-like-amount="isRemainingLikeAmount"
              />
            </template>
          </ul>
        </div>
      </div>
      <!-- ▲求人掲載リスト -->
    </div>
  </span>
</template>

<script>
import ScoutAndLikePeriodBar from '@/components/molecules/ScoutandLikePeriodBar'
import ScoutJobTopics from '@/components/organisms/ScoutJobTopics'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: { ScoutAndLikePeriodBar, ScoutJobTopics },
  props: {
    contractId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      associatedUserCountWithJobs: []
    }
  },
  computed: {
    contract () {
      return this.contracts(this.contractId)
    },
    ...mapGetters('contracts', [
      'contracts'
    ]),
    isRemainingLikeAmount () {
      return (this.contract.likeLimit - this.contract.sentLikeAmount) > 0
    }
  },
  created () {
    this.fetchJobs().then(response => {
      this.$set(this, 'associatedUserCountWithJobs', response.data)
      this.setSearchConditionId()
    })
  },
  methods: {
    fetchJobs () {
      return this.$http.secured.get(`/company/contracts/${this.contractId}/jobs`)
    },
    getAssociatedUserCountWithJob (jobId) {
      return _.defaultTo(_.find(this.associatedUserCountWithJobs, { jobId: Number(jobId) }), {})
    },
    setSearchConditionId () {
      this.associatedUserCountWithJobs.forEach(associatedUserCountWithJob => {
        associatedUserCountWithJob.latestSearchConditionId && this.$store.dispatch('contracts/setSearchConditionId', {
          value: associatedUserCountWithJob.latestSearchConditionId,
          jobId: associatedUserCountWithJob.jobId
        })
      })
    }
  }
}
</script>
